module.exports = __webpack_public_path__ + "static/media/mongo.4b5ff800.jpg";